import NoSpotAvailablePage from './NoSpotAvailablePage';
import { NoSpotAvailablePageProps, NoSpotAvailablePageValueProps } from './types';

export type { NoSpotAvailablePageProps, NoSpotAvailablePageValueProps };
export default NoSpotAvailablePage;
